import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/setting_option_selected.svg'
import _imports_1 from '@/assets/img/setting_option.svg'
import _imports_2 from '@/assets/img/setting_option_active.svg'


const _withScopeId = n => (_pushScopeId("data-v-95c260b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main tw-overflow-x-hidden" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(`tw-bg-[#fff] xl:tw-px-[60px] tw-px-[10px] xl:tw-py-[55px] tw-py-[30px]`)
}
const _hoisted_3 = {
  style: {"line-height":"22px"},
  class: "title tw-text-2xl tw-font-semibold tw-text-[#211F58] tw-text-[22px]"
}
const _hoisted_4 = { class: "assessment-content" }
const _hoisted_5 = { id: "vendor-assess-manage-requested" }
const _hoisted_6 = { class: "title-container tw-flex tw-items-center tw-justify-between" }
const _hoisted_7 = { class: "tw-my-0" }
const _hoisted_8 = { class: "title tw-mr-[10px]" }
const _hoisted_9 = {
  id: "vendor-assess-manage-group-button",
  class: "group-button tw-flex tw-items-center"
}
const _hoisted_10 = { class: "tw-cursor-pointer" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_13 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_14 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_15 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-gap-[25px] tw-mt-[20px] tw-w-full tw-rounded-[6px]"
}
const _hoisted_16 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[72px] tw-rounded-[6px]"
}
const _hoisted_17 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-[20px] tw-my-[20px]"
}
const _hoisted_18 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]" }
const _hoisted_19 = { class: "tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-py-[50px] tw-px-[25px] tw-gap-[20px] tw-rounded-[6px] tw-bg-[#FFF]" }
const _hoisted_20 = { class: "tw-m-0 tw-text-[#878787] tw-text-[15px] tw-leading-[145%] tw-font-normal" }
const _hoisted_21 = { class: "tw-mt-[40px]" }
const _hoisted_22 = { class: "tw-mb-5 tw-py-[8px] tw-w-full tw-flex tw-justify-between tw-items-center tw-text-[#211F58] tw-text-[18px] tw-font-semibold tw-leading-[100%]" }
const _hoisted_23 = {
  key: 0,
  class: "tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-border-solid tw-border-[1px] tw-border-[#EFF0F1] action-width tw-rounded-[6px] tw-min-w-[261px] tw-w-[420px] tw-flex tw-flex-col tw-items-center tw-justify-center"
}

import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import IconButton from "@/components/common/iconButton.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import { getComponentUiText } from "@/utils/utilities";
import ProviderMinidash from "@/components/vendor/providerMinidash.vue";
import store from "@/store";
import VendorAssessmentDetails from "@/components/vendor/vendorAssessmentDetails.vue";
import AssessmentCreateButton from "@/components/assessment/assessmentCreateButton.vue";
import VendorAssessmentTemplate from "@/components/vendor/vendorAssessmentTemplate.vue";
import { computed, onBeforeUnmount, onMounted, Ref, ref, watch } from "vue";
import { MODAL_NAME } from "@/utils/constants";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IModalMessage } from "@/interfaces/common/common";
import AssessmentDisplayOptions from "@/components/assessment/assessmentDisplayOptions.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import NoteInfo from "@/components/common/noteInfo.vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessments',
  setup(__props) {

const isHoverDisplayOptions: Ref<boolean> = ref(false);
const popover_display_options: any = ref(null);
const isShowToolTipDisplayOptions: Ref<boolean> = ref(false);
const isChecklistDetailLoading = ref(true);
const assessmentSelected: Ref<number[]> = ref([]);
const notInfoVisible = ref(true);
const route = useRoute();

const showDeletedAssessments: Ref<boolean> = ref(
  store.state.Vendor.isShowArchivedChecklist,
);

const checklistDetailData = computed(
  () => store.state.Vendor.requestedChecklist,
);

const providerData = computed(() => {
  const clr = [...store.state.Vendor.requestedChecklist];
  const providers = [...store.state.Vendor.listProvider];
  providers.forEach((provider) => {
    const findIndex = clr.findIndex((i) => i.providerId === provider.id);
    if (findIndex === -1) {
      clr.push({
        providerId: provider.id,
        providerName: provider.name,
        checklistRequestedHistory: [],
      });
    } else {
      clr[findIndex].providerName = provider.name;
    }
  });
  return clr;
});

const isCheckToggleDisplayOptions: Ref<boolean> = computed(
  () => showDeletedAssessments.value,
);

const displayOptions = computed(() => [
  {
    title: getComponentUiText(
      "app-component-vendor-assessment-display-options-show-deleted-1",
    ),
    value: showDeletedAssessments.value,
    action: handleShowDeletedAssessments,
    dataCy: "show-deleted-assessments",
  },
]);

const isMenuPin = computed(
  () =>
    store.state.Navigation.chevronActive && store.state.Navigation.isMenuOpen,
);

const currentOrg = computed(() => store.state.Org.currentOrg);
const totalRequestedChecklistArchived = computed(
  () => store.state.Vendor.totalRequestedChecklistArchived,
);

const containerRef: any = ref(null);
const isStacked = ref(false);
let observer: any = null;

onMounted(() => {
  const checkStacked = () => {
    const [el1, el2] = containerRef.value.children;
    requestAnimationFrame(() => {
      isStacked.value = el1.offsetTop !== el2.offsetTop;
    });
  };
  const param = route?.query?.param;
  if (param === "OpenModalCreateAssessment") {
    openModalCreateVendorAssessment();
  }
  observer = new ResizeObserver(checkStacked);
  observer.observe(containerRef.value);
  requestAnimationFrame(() => {
    checkStacked();
  });
});

onBeforeUnmount(() => {
  if (observer && containerRef.value) observer.unobserve(containerRef.value);
});

const openPopoverDisplayOption = () => {
  setTimeout(() => {
    popover_display_options?.value?.$emit("show");
  }, 500);
};

const filterChecklistArchived = () => {
  const list = store.state.Vendor.requestedChecklist;
  const result = list
    .map((i) => ({
      ...i,
      checklistRequestedHistory: i.checklistRequestedHistory.filter(
        (c) => !c.isArchived,
      ),
    }))
    .filter((item) => item.checklistRequestedHistory.length > 0);

  if (result.length === 0) return [];
  else return result.flatMap((item) => item.checklistRequestedHistory);
};

const handleShowDeletedAssessments = async () => {
  showDeletedAssessments.value = !showDeletedAssessments.value;

  await store.commit(
    "Vendor/SET_IS_SHOW_ARCHIVED_CHECKLIST",
    showDeletedAssessments.value,
  );

  // Call api GET deleted assessment or set previous assessment.
  if (showDeletedAssessments.value) {
    await store.dispatch("Vendor/fetchRequestedChecklist", {
      isArchived: true,
    });
  } else {
    await store.commit(
      "Vendor/SET_REQUESTED_CHECKLIST",
      filterChecklistArchived(),
    );
  }
};

onMounted(() => {
  init();
});

watch(
  () => currentOrg.value.orgId,
  (newVal, oldVal) => {
    if (newVal !== oldVal && newVal && oldVal) {
      isChecklistDetailLoading.value = true;
      init();
    }
  },
);

const init = async () => {
  await store.dispatch("Vendor/fetchRequestedChecklist", {
    isArchived: showDeletedAssessments.value,
  });
  await store.dispatch("Vendor/fetchRequestedTemplate");
  await store.dispatch("Vendor/fetchProviderList");
  isChecklistDetailLoading.value = false;
};

const handleSelectAssessment = (checklistId: number) => {
  if (assessmentSelected.value.includes(checklistId)) {
    assessmentSelected.value = assessmentSelected.value.filter(
      (id) => id !== checklistId,
    );
  } else {
    assessmentSelected.value = [...assessmentSelected.value, checklistId];
  }
};

const openModalCreateVendorAssessment = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_CREATE_NEW_VENDOR_ASSESSMENT,
    properties: {},
    events: {
      "update:data": () => {},
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const openModalAddVendorAssessment = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_MANAGE_VENDOR_DETAIL,
    properties: {},
    events: {
      "update:data": () => {},
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createBlock(AppBarLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ActivePathWrapper, {
          "active-hierarchy": [
            _unref(getComponentUiText)('app-menu-assess-1'),
            _unref(getComponentUiText)('app-menu-submenu-assess-vendor-assessments-1'),
          ]
        }, null, 8, ["active-hierarchy"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-menu-submenu-assess-vendor-assessments-1")), 1)
        ]),
        _createElementVNode("div", {
          ref_key: "containerRef",
          ref: containerRef,
          class: _normalizeClass(`content-wrapper ${isMenuPin.value ? 'content-wrapper-pin' : ''}`)
        }, [
          _createElementVNode("div", {
            id: "click-box-assessment",
            style: _normalizeStyle({
              order: !isStacked.value ? 1 : 2,
            }),
            class: _normalizeClass(`tw-gap-0 content assessment-container 
              assessment-container-pin content-pin
            `)
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(getComponentUiText)("app-vendor-assessment-title-1")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(ButtonBulkActions, {
                      "id-popover": 'vendor-assessment-manage-builk-btn',
                      active: assessmentSelected.value?.length >= 1,
                      "selected-number": assessmentSelected.value.length,
                      "button-class": "!tw-mr-[20px]"
                    }, null, 8, ["active", "selected-number"]),
                    _createVNode(ButtonFilter, {
                      active: false,
                      "id-popover": 'vendor-assessment-manage-filter-btn',
                      "button-class": "!tw-mr-[20px]"
                    }),
                    _createElementVNode("div", {
                      id: "manage-vendor-display-settings popover-target-1",
                      "data-cy": "vendor-assessment-display-settings",
                      class: _normalizeClass(["toggle-switch-view tw-relative tw-px-[14px] tw-py-[10px] !tw-mr-[20px]", 
                        isCheckToggleDisplayOptions.value
                          ? 'setting-option-selected'
                          : ''
                      ]),
                      onClick: openPopoverDisplayOption,
                      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHoverDisplayOptions.value = true)),
                      onMouseout: _cache[1] || (_cache[1] = ($event: any) => (isHoverDisplayOptions.value = false))
                    }, [
                      _createElementVNode("label", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, [
                          (isCheckToggleDisplayOptions.value)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                            : (
                              !isShowToolTipDisplayOptions.value &&
                              !isHoverDisplayOptions.value
                            )
                              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                              : (_openBlock(), _createElementBlock("img", _hoisted_14))
                        ])
                      ])
                    ], 34),
                    _createVNode(_component_b_popover, {
                      ref_key: "popover_display_options",
                      ref: popover_display_options,
                      target: "manage-vendor-display-settings popover-target-1",
                      placement: "bottom-end",
                      click: "true",
                      offset: 20,
                      style: {"max-width":"290px !important"},
                      "custom-class": `custom-actions-popover assessment-display-options`,
                      class: "tw-absolute",
                      onShow: _cache[2] || (_cache[2] = ($event: any) => (isShowToolTipDisplayOptions.value = true)),
                      onHidden: _cache[3] || (_cache[3] = ($event: any) => (isShowToolTipDisplayOptions.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(AssessmentDisplayOptions, {
                          "list-option": displayOptions.value,
                          class: _normalizeClass('!tw-w-[290px]')
                        }, null, 8, ["list-option"])
                      ]),
                      _: 1
                    }, 512),
                    _createVNode(IconButton, {
                      id: "vendor-assess-manage-btn-open-modal-create",
                      "data-cy": "add-new-vendor-assessment-btn",
                      src: "/img/plus_icon.svg",
                      onClick: openModalCreateVendorAssessment
                    })
                  ])
                ]),
                (checklistDetailData.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (isChecklistDetailLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(checklistDetailData.value, (item, index) => {
                            return (_openBlock(), _createBlock(VendorAssessmentDetails, {
                              key: item.checklistId || item.dateUpdated,
                              details: item,
                              index: index,
                              "checklist-id": item.checklistId,
                              "onSelect:assessment": handleSelectAssessment,
                              onLoaded: () => {},
                              onOnRefresh: () => {}
                            }, null, 8, ["details", "index", "checklist-id"]))
                          }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (notInfoVisible.value && totalRequestedChecklistArchived.value)
                        ? (_openBlock(), _createBlock(NoteInfo, {
                            key: 0,
                            onClose: _cache[4] || (_cache[4] = () => (notInfoVisible.value = false))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(getComponentUiText)(
                          "app-component-assessments-vendor-assessment-no-asessment-note-info-1",
                        )), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(getComponentUiText)(
                          "app-component-assessments-vendor-assessment-no-asessment-description-1",
                        )), 1),
                        _createElementVNode("p", {
                          class: "tw-m-0 tw-text-[#387DFF] tw-text-[11px] tw-leading-[145%] tw-font-medium tw-cursor-pointer",
                          onClick: openModalCreateVendorAssessment
                        }, _toDisplayString(_unref(getComponentUiText)(
                          "app-component-assessments-vendor-assessment-no-asessment-action-1",
                        )), 1)
                      ])
                    ]))
              ]),
              _createElementVNode("div", {
                id: "vendor-assess-manage-template",
                class: _normalizeClass(`${
                  checklistDetailData.value.length ? 'tw-mt-[40px]' : 'tw-mt-[0px]'
                }`)
              }, [
                _createVNode(VendorAssessmentTemplate, { onRefresh: init })
              ], 2),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(AssessmentCreateButton, {
                  id: "vendor-assess-manage-btn-create",
                  "data-cy": "vendor-assess-manage-send-new-assessment-btn",
                  title: `
                    ${
                      checklistDetailData.value.length
                        ? _unref(getComponentUiText)(
                            'app-component-assessments-vendor-assessment-send-a-new-assessment-1',
                          )
                        : _unref(getComponentUiText)(
                            'app-component-assessments-vendor-assessment-create-your-first-vendor-assessment-1',
                          )
                    }
                  `,
                  "btn-style": 'tw-px-[25px] tw-py-[16px]',
                  onClick: openModalCreateVendorAssessment
                }, null, 8, ["title"])
              ])
            ])
          ], 4),
          _createElementVNode("div", {
            class: _normalizeClass(`tw-h-[fit-content] action-width tw-min-w-[261px] tw-w-[420px] tw-flex tw-items-center tw-flex-col ${
              !isStacked.value ? 'tw-order-2' : 'tw-order-1 !tw-pt-0'
            }`)
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessments-vendor-mini-dash-title-1",
                )) + " ", 1),
              _createVNode(IconButton, {
                id: "vendor-assess-manage-btn-open-modal-create",
                "data-cy": "add-new-vendor-btn",
                src: "/img/plus_icon.svg",
                onClick: openModalAddVendorAssessment
              })
            ]),
            (providerData.value && providerData.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createVNode(ProviderMinidash, { data: providerData.value }, null, 8, ["data"])
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ], 2)
      ])
    ]),
    _: 1
  }))
}
}

})